export enum InvitationStatus {
  Pending,
  Accepted,
  Deleted
}
